import { render, staticRenderFns } from "./DocutaxSubmissions.vue?vue&type=template&id=0dbd1af4&scoped=true&"
import script from "./DocutaxSubmissions.vue?vue&type=script&lang=js&"
export * from "./DocutaxSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./DocutaxSubmissions.vue?vue&type=style&index=0&id=0dbd1af4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbd1af4",
  null
  
)

export default component.exports